import styles from "./LandingHeader.module.scss";
import logo from "../../assets/wattlord-logo.svg";
import { useIntl } from "react-intl";

function LandingHeader() {
  const { formatMessage } = useIntl();

  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <img src={logo} alt="WattLord" />
      </div>
      <div className={styles.actions}>
        <nav className={styles.nav}>
          <a href="#video-reviews">
            {formatMessage({ id: "wlp.header.videoReviews" })}
          </a>
          <a href="#benefits">{formatMessage({ id: "wlp.header.benefits" })}</a>
          <a href="#contact-us">{formatMessage({ id: "wlp.header.contact" })}</a>
        </nav>
      </div>
    </header>
  );
}

export { LandingHeader };
